import useResource from "./useResource";
import { Select } from "antd";
import { useState, useEffect } from "react";
const Resource = ({
  customComponent,
  resource,
  handleResourceDropCb,
  allowDropOnSchedular,
  providers,
  handleUpdateRooms,
  isDropDownActive,
}) => {
  providers = providers?.filter((x) => x.id !== resource.provider_id);
  const { Component, props = {} } = customComponent;
  const { drop } = useResource({ handleResourceDropCb, resource });
  const [selectedProvider, setSelectedProvider] = useState(null);
  const abbreviateName = (name) => {
    if (!name) return "";
    return name
      .split(" ")
      .map((word) => word[0]?.toUpperCase())
      .join("");
  };

  useEffect(() => {
    setSelectedProvider(resource.provider_id);
  }, [resource]);
  const hanldeProviderUpdate = async (value) => {
    setSelectedProvider(value);
    // const eventType = "assign_provider_to_room";
    // const payload = {
    //   allocate_all: false,
    //   provider_id: value,
    //   room_id: resource.id,
    //   zohoMirrorId: null,
    //   event_type: eventType,
    // };
    const payload = {
      allocate_all: false,
      id: resource.id,
      providerId: value,
      zohoMirrorId: null,
    };

    // await handleUpdateRooms(payload, eventType);
    // Also trigger drop callback so behavior matches drag-drop
    if (handleResourceDropCb) {
      handleResourceDropCb(payload);
    }
  };
  return (
    <div className="resource" ref={allowDropOnSchedular ? drop : null}>
      {Component ? (
        <Component resource={resource} {...props} />
      ) : (
        <span className="resource-name">{resource?.name}</span>
      )}
      {(resource.provider_id == null || resource.provider_id == "") &&
        isDropDownActive == true &&
        providers?.length > 0 && (
          <Select
            size="small"
            placeholder="Select"
            value={selectedProvider ?? undefined}
            onChange={(value) => hanldeProviderUpdate(value)}
            showSearch={false}
            popupClassName="resource-dropdown"
            dropdownMatchSelectWidth={false}
            optionLabelProp="label"
            onTouchStart={(e) => e.stopPropagation()}
            onTouchEnd={(e) => e.stopPropagation()}>
            {providers.map((provider) => (
              <Select.Option
                key={provider.id}
                value={provider.id}
                label={abbreviateName(provider.name)}>
                {provider.name}
              </Select.Option>
            ))}
          </Select>
        )}
    </div>
  );
};

export default Resource;
